__turbopack_context__.v({
  "card": "cr0zNW_card",
  "cards": "cr0zNW_cards",
  "caret": "cr0zNW_caret",
  "content": "cr0zNW_content",
  "desc": "cr0zNW_desc",
  "disclaimer": "cr0zNW_disclaimer",
  "disclaimerTitle": "cr0zNW_disclaimerTitle",
  "imgDesktop": "cr0zNW_imgDesktop",
  "imgMobile": "cr0zNW_imgMobile",
  "root": "cr0zNW_root",
  "textContent": "cr0zNW_textContent",
});
